const brandsEvents = {
  select: 'app/modules/brands/select',
  load: {
    start: 'app/modules/brands/load/start',
    success: 'app/modules/brands/load/success',
    error: 'app/modules/brands/load/error',
    finish: 'app/modules/brands/load/finish',
  },
  modal: {
    open: 'app/modules/brands/modal/open',
    close: 'app/modules/brands/modal/close',
    save: 'app/modules/brands/modal/save',
  },
  revoke: {
    open: 'app/modules/brands/revoke/open',
    close: 'app/modules/brands/revoke/close',
    save: 'app/modules/brands/revoke/save',
  },
  adminSettings: {
    open: 'app/modules/brands/admin-settings/open',
    close: 'app/modules/brands/admin-settings/close',
    save: 'app/modules/brands/admin-settings/save',
  },
};

export default brandsEvents;
